<template>
    <v-card class="mx-auto pa-2 mt-5 notifications-card">
        <v-list>
            <v-toolbar-title class="ml-4 font-medium subtitle"
                >Notifications</v-toolbar-title
            >
            <div class="notification-list">
                <v-list-item
                    v-for="(item, i) in items"
                    :key="i"
                    :value="item"
                    active-color="#dba002"
                    rounded="shaped"
                    class="pt-3 pb-3"
                >
                    <template v-slot:prepend>
                        <v-icon :icon="item.icon"></v-icon>
                    </template>

                    <v-list-item-title v-text="item.title"></v-list-item-title>
                    <v-list-item-subtitle
                        v-text="item.time"
                    ></v-list-item-subtitle>
                </v-list-item>
            </div>
        </v-list>
    </v-card>
</template>
<script>
export default {
    data: () => ({
        selectedItem: 1,
        items: [
            {
                title: "Try our latest and greatest products. On sale NOW!",
                time: "now",
                icon: "mdi-gift",
            },
            {
                title: "New customer care ticket issued - #23556",
                time: "2m ago",
                icon: "mdi-ticket",
            },
            {
                title: "Your password has been reset. Take action if this wasn't you.",
                time: "2m ago",
                icon: "mdi-account",
            },
            {
                title: "There is a security vulnerability with your account. Fix now.",
                time: "4h ago",
                icon: "mdi-flag",
            },
            {
                title: "Attempt to contact account holder failed. Please update your contact details.",
                time: "6d ago",
                icon: "mdi-alert",
            },
            {
                title: "Regular system checks have been activated. Head over to the control panel.",
                time: "1w ago",
                icon: "mdi-clock",
            },
            {
                title: "Welcome to the EnergyHub family! Learn some tips and tricks now.",
                time: "1w ago",
                icon: "mdi-account",
            },
        ],
    }),
};
</script>
<style lang="scss" scoped>
.notifications-card {
    width: 500px;
    height: 455px;
    margin-left: 100px !important;
}
.notification-list {
    overflow-y: scroll;
    height: 400px;
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: $dark-gray;
        border-radius: 10px;
    }
}
</style>
